export default "__VITE_ASSET__DlV8BzPH__"